import { getUrlsTable } from '@repo/shared-config/constants/hosts';
import { getEnvironmentVariables } from '@repo/shared-config/helper/environment-variables';

// backendUrlsTable can be undefined at runtime when environment variables are not available
// (e.g., in unit tests without DOM/meta tags), even though TypeScript types say otherwise
const { backendUrlsTable } = getUrlsTable(getEnvironmentVariables());

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- runtime safety for test environments
export const apiBaseURL = backendUrlsTable?.apiBaseURL ?? '';
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- runtime safety for test environments
export const registerBaseURL = backendUrlsTable?.registerBaseURL ?? '';
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- runtime safety for test environments
export const registerPartnersBaseURL = backendUrlsTable?.registerPartnersBaseURL ?? '';
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- runtime safety for test environments
export const billerBaseURL = backendUrlsTable?.billerBaseURL ?? '';
